/**
 * @auth 赖传峰
 * @date 2022/3/18
 */
import type { CookieOptions } from '#app'
import {
  Effect,
  type ElTooltipProps,
} from 'element-plus'
import type { DisplayModeStruct } from '~/composables/DisplayMode'
import {
  FileOrder,
  SupportLocale,
  ViewType,
} from '~/types/enum'

export const DEFAULT_LOCALE = SupportLocale.EN_US

export const API_ITEMS_UPPER_LIMIT = 500 // 服务器单次处理数据量的上限，包括获取数据，生成数据，删除数据

export const TIME_FORMAT_STRING = 'YY-MM-DD HH:mm'

export const FILE_MODIFIED_TIME_PLACEHOLDER = '__-__-__ __:__'

export const PREVIEW_TIME_UPPER_LIMIT = 120 // 秒

export const DOMAIN_LIST = ['mypikpak.com', 'pikpakdrive.com', 'mypikpak.net', 'pikpak.me'] as const

export const APP_DEEPLINK_PREFIX = 'pikpakapp://mypikpak.com' as const
export const DEEP_LINK_PREFIX = `${APP_DEEPLINK_PREFIX}/xpan` as const

export const TOOLTIP_COMMON_PROPS = {
  placement: 'top' as ElTooltipProps['placement'],
  effect: Effect.DARK,
  hideAfter: 0,
}
export const APPLE_SILICON_DOWNLOAD_LINK = 'https://static.mypikpak.com/mac/PikPak_Mac_AppleSilicon.dmg' as const
export const INTEL_DOWNLOAD_LINK = 'https://static.mypikpak.com/mac/PikPak_Mac_Intel.dmg' as const
export const COOKIE_OPTIONS: Pick<CookieOptions, 'sameSite' | 'secure'> = { sameSite: 'strict', secure: true }
export const DEFAULT_DISPLAY_MODE: Readonly<DisplayModeStruct> = {
  orderType: FileOrder.MODIFY_TIME_DESC,
  pinFoldersTop: true,
  orderSettingGlobal: false,
  viewType: ViewType.GRID,
  viewSettingGlobal: false,
}

export const OG_SITE_NAME = 'PikPak Drive'
export const EMAIL_REGEX = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/
export const BOT_REGEX = /bot|crawl|spider|slurp|sohu-search|lycos|robozilla|google|Baidu/i
